module.exports = __webpack_public_path__ + "static/media/iphone-12-1-x1.2a8abe1f.png";